<template>
  <div >

    <el-container>
      <el-aside width="calc(100% - 455px)">
        <div style="text-align: center;margin: 10px 0">
          <div class="title">{{blogData.title}}</div>
          <div class="react topping" v-if="blogData.topping === true">置顶</div>
          <div class="react essence" v-if="blogData.essence === true">精华</div>
        </div>

        <div style="text-align: center;margin: 10px 0">
          <div v-for="item in blogData.tags" :key="item.id" style="display: inline-block;margin: 10px 5px">
            <div class="react-tag" :style="getColorStyle(item.tag_col)">{{item.tag_name}}</div>
          </div>
        </div>

        <div  style="text-align: center;margin: 10px 0">
          <div class="time">创建时间：{{formatDate(blogData.create_blog_time)}}</div>
          <div class="time" v-if="blogData.create_blog_time !== blogData.last_update_time">最后修改时间：{{formatDate(blogData.last_update_time)}}</div>
        </div>

        <div style="margin-top: 30px">
          <MavonEditor ref="MavonEditor"></MavonEditor>
        </div>
      </el-aside>
      <el-main>
        <el-calendar></el-calendar>
      </el-main>
    </el-container>

  </div>
</template>

<script>

import MavonEditor from '../../widgets/MavonEditor'
import {getBlogDetail, getBlogTagList} from '../../../../request/api'
import Utils from '../../../../js/Utils'

export default {
  name: 'BlogInfo',
  components: {MavonEditor},
  data () {
    return {
      blogData: {},
      tags: [], // blog标签数据
      chooseTags: [] // blog输入的标签
    }
  },
  methods: {
    init () {
      var params = {'blog_id': this.$route.query.blog_id}

      getBlogDetail(params).then(res => {
        console.log(res)

        if (res.code === '90') {
          this.blogData = res.data

          this.$refs.MavonEditor.blogid = this.blogData.id
          this.$refs.MavonEditor.content = this.blogData.content

          if (this.blogData.tags !== null) {
            for (var i = 0; i < this.blogData.tags.length; i++) {
              var tagItem = this.blogData.tags[i]
              this.chooseTags.push(tagItem.id)
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error

        console.log(error)
      })

      getBlogTagList().then(res => {
        console.log(res)

        if (res.code === '90') {
          this.tags = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error
        console.log(error)
      })
    },
    formatDate (dateStr) {
      return Utils.formatDate(dateStr)
    },
    getColorStyle (color) {
      return 'background-color:' + color
    }

  },
  created () {
    this.init()
  }
}
</script>

<style scoped>

.title{
  display: inline-block;
  font-size: 28px;
  font-weight: bold;
  /*margin-top: 6px;*/
  margin-right: 10px;
}

.time{
  color: #909399;
  display: inline-block;
  margin: 0 20px;
}

.topping{
  background: dodgerblue;
}
.essence{
  background: red;
}

.react {
  padding: 3px 10px;
  margin-right: 5px;
  margin-bottom: -5px;
  display: inline-block;
  font-size: 12px;
  border-radius: 5px;
  color: white;
}

.react-tag{
  /*width: 50px;*/
  /*height: 26px;*/
  padding: 3px 10px;
  margin-right: 5px;
  text-align: center;
  /*transform: skewX(-20deg);*/
  /*margin-top: 8.5px;*/
  display: inline-block;
  font-size: 12px;
  border-radius: 5px;
  color: white;
}

.circular{
  border-radius: 12px;
  border:0px solid white;
  width: 22px;
  height: 22px;
  display: inline-block;
  /*margin-right: -10px;*/
  /*margin-top: 8px;*/
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/blog/BlogInfo.vue